goog.provide("shadow.js.shim.module$launchdarkly_react_client_sdk");
goog.provide("module$shadow_js_shim_module$launchdarkly_react_client_sdk");
shadow.js.shim.module$launchdarkly_react_client_sdk = shadow.js.nativeProvides["launchdarkly-react-client-sdk"] = shadow$bridge("launchdarkly-react-client-sdk");
module$shadow_js_shim_module$launchdarkly_react_client_sdk.default = shadow.js.shim.module$launchdarkly_react_client_sdk;
